import instance from './instance';
import { locale } from '../../i18n';
import { casEnabled, isColaborator } from '../../../auth/authService';
import TokenStrategyFactory from '../../../auth/tokenStrategies/tokenStrategyFactory';

function getToken() {
  const casTokenName = isColaborator() ? 'colaborator' : 'cas';
  const casToken = () => TokenStrategyFactory.getTokenStrategy(casTokenName).getToken();
  const jwtToken = () => TokenStrategyFactory.getTokenStrategy('jwt').getToken();
  return casEnabled() ? casToken() : jwtToken();
}

const configRequest = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
    Accept: 'application/json',
    'Content-Language': locale,
  },
});

export default class API {
  constructor(config = {}) {
    this.path = config.path;

    this.axios = instance();
  }

  get(resource = '', config = {}) {
    return this.axios.get(`${this.path}/${resource}`, Object.assign({}, configRequest(), config));
  }

  put(resource = '', data, config = {}) {
    return this.axios.put(`${this.path}/${resource}`, data, Object.assign({}, configRequest(), config));
  }

  post(resource = '', data, config = {}) {
    const path = `${this.path}/${resource}`;

    return this.axios.post(path, data, Object.assign({}, configRequest(), config));
  }

  delete(resource = '', config = {}) {
    return this.axios.delete(`${this.path}/${resource}`, Object.assign({}, configRequest(), config));
  }
}



// WEBPACK FOOTER //
// ./src/services/request/api/index.js